/** Configuração do único PWA e dos módulos internos do AutoFluxo. */

export type AppTargetId = 'geral' | 'crm' | 'vitrine' | 'simulador';

export interface AppTarget {
  id: AppTargetId;
  name: string;
  description: string;
  startPath: string;
  pathPrefixes: string[];
}

export const PWA_APP = {
  id: 'geral' as const,
  name: 'AutoFluxo',
  shortName: 'AutoFluxo',
  description: 'Sistema completo de gestão para revendas de veículos.',
  manifest: '/manifest.webmanifest',
  manifestId: '/?source=pwa',
  startPath: '/inicio',
  host: 'autofluxo.app',
  icon: '/icon-512x512.png',
  themeColor: '#0f172a',
};

export const APP_TARGETS: Record<AppTargetId, AppTarget> = {
  geral: {
    id: 'geral',
    name: 'AutoFluxo',
    description: 'Sistema completo: estoque, vendas, pessoas, financeiro e ferramentas.',
    startPath: '/inicio',
    pathPrefixes: [],
  },
  crm: {
    id: 'crm',
    name: 'AutoFluxo CRM',
    description: 'Atendimento, conversas, leads e funil de vendas.',
    startPath: '/crm/chat',
    pathPrefixes: ['/crm'],
  },
  vitrine: {
    id: 'vitrine',
    name: 'AutoFluxo Vitrine',
    description: 'Consulta rápida do estoque disponível para atendimento.',
    startPath: '/vitrine',
    pathPrefixes: ['/vitrine'],
  },
  simulador: {
    id: 'simulador',
    name: 'AutoFluxo Simulador',
    description: 'Simulações de cartão e financiamento com as taxas da rede.',
    startPath: '/simulador',
    pathPrefixes: ['/simulador', '/ferramentas/simulacoes'],
  },
};

export const APP_TARGET_LIST: AppTarget[] = [
  APP_TARGETS.geral,
  APP_TARGETS.crm,
  APP_TARGETS.vitrine,
  APP_TARGETS.simulador,
];

function loc(): { pathname: string } | null {
  const g = globalThis as unknown as {
    location?: { pathname: string };
  };
  return g.location ?? null;
}

/**
 * MÓDULO que está sendo visualizado (pelo caminho). Serve para navegação e
 * apresentação — nunca para decidir manifesto, ícone ou identidade instalada.
 */
export function resolveModuleFromPath(
  pathname: string = loc()?.pathname ?? '/',
): AppTargetId {
  const path = pathname.toLowerCase();
  const found = APP_TARGET_LIST.filter((app) => app.id !== 'geral').find((app) =>
    app.pathPrefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`)),
  );
  return found?.id ?? 'geral';
}

